function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M186.025,162.2a81.013,81.013,0,1,1-151.56-39.851A134.857,134.857,0,0,0,50.525,74.1l.393-2.877a54.594,54.594,0,0,1,108.188,0L159.5,74.1a134.374,134.374,0,0,0,5.48,23.744,148.959,148.959,0,0,0,11.074,25.388,80.639,80.639,0,0,1,9.972,38.97Z",
  transform: "translate(-23.999 -24)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M201.406,212.318A80.86,80.86,0,0,1,62.04,268.288c57.168-16.894,96.358-54.725,118.321-120.328a148.957,148.957,0,0,0,11.074,25.388,80.639,80.639,0,0,1,9.972,38.97Z",
  transform: "translate(-39.379 -74.119)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M84.809,170.31l-8.827-3.594c1.228-3.017,2.373-6.122,3.4-9.233l9.049,2.994C87.336,163.79,86.119,167.1,84.809,170.31Z",
  transform: "translate(-45.016 -77.97)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M51.266,249.243A65.913,65.913,0,0,1,48,228.7a66.69,66.69,0,0,1,8.611-32.807c1.37-2.421,2.689-4.917,3.918-7.417l8.555,4.2c-1.311,2.667-2.717,5.329-4.179,7.911a57.137,57.137,0,0,0-7.373,28.11,56.411,56.411,0,0,0,2.793,17.579Z",
  transform: "translate(-33.703 -90.499)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  d: "M442.717,122.716A66.684,66.684,0,0,1,376,56a66.666,66.666,0,0,1,66.717,66.717Z",
  transform: "translate(-166.319 -36.938)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  d: "M447.548,143.086a66.7,66.7,0,0,1-59.6-36.706,159.4,159.4,0,0,0,54.332,10.687,66.5,66.5,0,0,1,5.266,26.019Z",
  transform: "translate(-171.15 -57.308)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M353.475,86.182h-9.531V82.432c-.27-3.217-1.324-27.648,25.113-55.9l6.959,6.512C363.159,46.784,357.709,59.292,355.4,67.365c-2.49,8.709-1.96,14.275-1.955,14.33a4.234,4.234,0,0,1,.028.515Z",
  transform: "translate(-153.324 -25.025)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  d: "M351.5,170.1l-.393-2.88a54.594,54.594,0,0,0-108.187,0l-.393,2.88a134.775,134.775,0,0,1-16.06,48.25A80.625,80.625,0,0,0,216,258.2c0,44.7,36.948,81.355,81.648,81.013a81.033,81.033,0,0,0,70.4-119.983A141.917,141.917,0,0,1,351.5,170.1Z",
  transform: "translate(-101.628 -62.815)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M309.965,333.087a61.97,61.97,0,0,1-53.972-92.411,153.165,153.165,0,0,0,18.359-55.066l.393-2.881a35.532,35.532,0,0,1,70.413,0l.393,2.88a160.537,160.537,0,0,0,18.736,55.743,61.962,61.962,0,0,1-53.846,91.735Z",
  transform: "translate(-114.566 -75.752)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  d: "M381.774,338.886a42.889,42.889,0,1,1-8.351-25.43A42.889,42.889,0,0,1,381.774,338.886Z",
  transform: "translate(-133.969 -133.971)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  d: "M365.774,322.886a42.889,42.889,0,1,1-8.351-25.43A42.889,42.889,0,0,1,365.774,322.886Z",
  transform: "translate(-127.5 -127.502)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M374.621,334.74a42.884,42.884,0,0,1-72.751,30.779c26.151-12.569,47.583-31,64.4-56.209a42.7,42.7,0,0,1,8.351,25.43Z",
  transform: "translate(-136.347 -139.356)",
  fill: "rgba(147,147,147,0.69)"
});

function SvgAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ava",
    xmlns: "http://www.w3.org/2000/svg",
    width: 276.399,
    height: 276.399,
    viewBox: "0 0 276.399 276.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva);
export default __webpack_public_path__ + "static/media/ava.0265d688.svg";
export { ForwardRef as ReactComponent };